import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import {
  formatErrorMessage,
  rejectErrorCodeHelper,
  formatErrorMessageBaseOnCodeFinancialProfile,
} from '../../util/helpers/registerRejectErrorCodeHelper';
import {
  getFundingSourceRequest,
  createApplicationFundingSourceRequest,
  updateApplicationFundingSourceRequest,
  getAccountFundingDetails,
  getAccountPurposeRequest,
} from '../../request/fundingSourceRequest';
import {
  getFundingSourceSuccess,
  getFundingSourceError,
  applicationFundingSourceSuccess,
  applicationFundingSourceError,
  updateApplicationFundingSourceSuccess,
  updateApplicationFundingSourceError,
  setFundingSourceDetails,
  getFundingPurposeSuccess,
  getFundingPurposeError,
} from '../actions/fundingSource/fundingSourceActions';
import {
  GET_FUNDING_SOURCE,
  APPLICATION_FUNDING_SOURCE,
  UPDATE_APPLICATION_FUNDING_SOURCE,
  GET_FUNDING_SOURCE_ACCOUNT_DETAILS,
  GET_FUNDING_ACCOUNT_PURPOSE,
} from '../actions/fundingSource/FundingSourceConstants';

function* fetchFundingSource() {
  try {
    const { data } = yield call(getFundingSourceRequest);
    yield put(getFundingSourceSuccess(data));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getFundingSourceError(errMsg));
  }
}

function* fetchAccountPurposeSource() {
  try {
    const { data } = yield call(getAccountPurposeRequest);
    yield put(getFundingPurposeSuccess(data));
  } catch (error) {
    const errMsg = formatErrorMessage(error);
    yield put(getFundingPurposeError(errMsg));
  }
}

function* applicationSourceFunding({ payload }) {
  try {
    const { data } = yield call(createApplicationFundingSourceRequest, {
      applicationUid: payload.applicationUid,
      data: payload.data,
    });
    if (payload?.onSuccess) {
      yield put(applicationFundingSourceSuccess(data));
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const { fieldName, errorMessage } = yield call(
      formatErrorMessageBaseOnCodeFinancialProfile,
      error,
    );
    yield put(applicationFundingSourceError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
        field: fieldName,
      });
    }
  }
}

function* getFundingSourceDetails({ payload }) {
  try {
    const { data } = yield call(getAccountFundingDetails, {
      applicationUid: payload.applicationUid,
    });
    if (data) {
      yield put(setFundingSourceDetails(data));
    }
  } catch (error) {
    const errorMessage = yield call(rejectErrorCodeHelper, error);
    yield put(applicationFundingSourceError(errorMessage));

    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
      });
    }
  }
}

function* updateApplicationSourceFunding({ payload }) {
  try {
    const { data } = yield call(updateApplicationFundingSourceRequest, {
      applicationUid: payload.applicationUid,
      data: payload.data,
    });
    if (payload?.onSuccess) {
      yield put(updateApplicationFundingSourceSuccess(data));
      yield call(payload.onSuccess);
    }
  } catch (error) {
    const { fieldName, errorMessage } = yield call(
      formatErrorMessageBaseOnCodeFinancialProfile,
      error,
    );
    yield put(updateApplicationFundingSourceError(errorMessage));
    if (payload?.onError) {
      yield call(payload.onError, {
        type: 'manual',
        message: errorMessage,
        field: fieldName,
      });
    }
  }
}

export default function* fundingSourceSaga() {
  yield all([
    takeLatest(GET_FUNDING_SOURCE, fetchFundingSource),
    takeLatest(APPLICATION_FUNDING_SOURCE, applicationSourceFunding),
    takeLatest(
      UPDATE_APPLICATION_FUNDING_SOURCE,
      updateApplicationSourceFunding,
    ),
    takeLatest(GET_FUNDING_SOURCE_ACCOUNT_DETAILS, getFundingSourceDetails),
    takeLatest(GET_FUNDING_ACCOUNT_PURPOSE, fetchAccountPurposeSource),
  ]);
}
